import "./context/auth/androidDesktopLayout";
import "./context/o11y/initialize";

//import "./wydr";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import "./styles/common.css";
import { LicenseManager } from "ag-grid-enterprise";
import { AG_KEY } from "./globals";
import { installChunkReloadHandler } from "./utils/chunkReload";

LicenseManager.setLicenseKey(AG_KEY);

// Recover from stale code-split chunks after a deploy (e.g. clicking Settings
// on an old tab) by reloading the page to fetch the latest assets.
installChunkReloadHandler();

const rootEl = document.getElementById("root");

if (!rootEl) {
  throw new Error("No root element");
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
